var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 78,
    viewBox: "0 0 85 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Weddingday\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0265 8.64648H50.8826V10.3284C50.8826 15.0029 54.6559 18.7601 59.3106 18.7601C63.9558 18.7601 67.7386 14.9851 67.7386 10.3284V8.64648H77.8479C80.6431 8.64648 82.9091 10.9091 82.9091 13.7143V71.003C82.9091 73.8018 80.6607 76.0707 77.8479 76.0707H7.06123C4.26599 76.0707 2 73.8081 2 71.003V13.7143C2 10.9154 4.24842 8.64648 7.06123 8.64648H17.1705V10.3284C17.1705 15.0029 20.9438 18.7601 25.5985 18.7601C30.2437 18.7601 34.0265 14.9851 34.0265 10.3284V8.64648Z",
    fill: "#81A4E3",
    stroke: "#314E55",
    strokeWidth: 3.37121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.9697 6.96063C28.9697 4.16782 27.4604 1.90381 25.5985 1.90381C23.7366 1.90381 22.2273 4.16782 22.2273 6.96063V8.64623C22.2273 11.439 23.7366 13.7031 25.5985 13.7031C27.4604 13.7031 28.9697 11.439 28.9697 8.64623V6.96063Z",
    fill: "#D8D8D8",
    stroke: "#314E55",
    strokeWidth: 3.37121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.6818 6.96063C62.6818 4.16782 61.1725 1.90381 59.3106 1.90381C57.4487 1.90381 55.9394 4.16782 55.9394 6.96063V8.64623C55.9394 11.439 57.4487 13.7031 59.3106 13.7031C61.1725 13.7031 62.6818 11.439 62.6818 8.64623V6.96063Z",
    fill: "#D8D8D8",
    stroke: "#314E55",
    strokeWidth: 3.37121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74243 25.5024H76.1667V71.0138H8.74243V25.5024Z",
    fill: "#D8D8D8",
    stroke: "#314E55",
    strokeWidth: 3.37121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0121 36.8684C29.6666 38.5365 28.037 44.8206 30.3723 50.9043C32.705 56.9813 42.2163 61.4238 42.2163 61.4238C42.2163 61.4238 52.2041 56.9813 54.5368 50.9043C56.8721 44.8206 55.2426 38.5365 50.897 36.8684C48.1619 35.8185 45.0027 36.8475 42.4546 39.2714C42.4546 39.2714 36.7472 35.8185 34.0121 36.8684Z",
    fill: "#E65F58",
    stroke: "#314E55",
    strokeWidth: 3.37121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.9f6909b422869fe6e465ac37591bbdc9.svg";
export { ForwardRef as ReactComponent };